module.exports = "mutation ($id: ID!, $data: UserUpdate!) {\n  UserUpdate(id: $id, data: $data) {\n    id\n  }\n}\n"